import { render, staticRenderFns } from "./AdmissionExaminationRoomTeacher.vue?vue&type=template&id=6b22ffe3&"
import script from "./AdmissionExaminationRoomTeacher.vue?vue&type=script&lang=js&"
export * from "./AdmissionExaminationRoomTeacher.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionExaminationRoomTeacher.vue?vue&type=style&index=0&id=6b22ffe3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports